/** @format */
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import NotesSVG from '@toucan/client/global/icons/notes.svg';

import { ProductDetailsListItem } from '../product-details-list-item';
import { styles } from './product-observations-list-item.styles';
import { ProductDetailsListItemObservationProps } from './types';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'product-observations-list-item';

export const StyledProductObservationsListItem = styled(ProductDetailsListItem)`
    ${styles}
`;

export const ProductObservationsListItem: FunctionComponent<
    ProductDetailsListItemObservationProps
> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    observations,
    ...otherProps
}) => {
    const { t } = useTranslation();

    const observationsWithTierDescription = observations.filter(
        ({ tierDescription }) => tierDescription
    );

    return (
        <StyledProductObservationsListItem
            {...otherProps}
            data-testid={dataTestId}
            icon={<NotesSVG />}
            title={<strong>{t('Notes')}</strong>}
        >
            <ul data-testid={`${dataTestId}__notes`}>
                {observationsWithTierDescription.map(
                    ({ tierDescription, observationId, tierId }) => (
                        <li
                            key={`${observationId}-${tierId}`}
                            data-testid={`${dataTestId}__note`}
                        >
                            {tierDescription}
                        </li>
                    )
                )}
            </ul>
        </StyledProductObservationsListItem>
    );
};
